import { render } from "./TelaRecuperacao.vue?vue&type=template&id=449f7c4b"
import script from "./TelaRecuperacao.vue?vue&type=script&lang=js"
export * from "./TelaRecuperacao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__